import React, { ReactElement } from 'react';

import Dica from 'components/ui/dica';
import { FOCO_VISIVEL } from 'utils/foco';

interface HumanogramaLinkProps {
  id?: string;
  name?: string;
  data?: any;
  children: ReactElement;
}

/**
 * Link para o Humanograma com a dica dos dados da pessoa, na nova identidade (AJH-22). O link herda a
 * cor do texto que embrulha: o `hover:text-white` antigo apagava o nome sobre os cartões claros. O anel de foco do
 * teclado é o do app (RDV-25, WCAG 2.4.7).
 */
const Humanograma: React.FC<HumanogramaLinkProps> = ({ data, children }) => {
  // A dica fica no link, que já recebe o foco: abre no mouse e no Tab, sem o filho precisar de `tabIndex`.
  return (
    <Dica
      conteudo={
        <>
          <p className="m-0">
            Nome: <strong>{data?.nome}</strong>
          </p>
          <p className="m-0">
            Função: <strong>{data?.funcao}</strong>
          </p>
          <p className="m-0">
            Prefixo:{' '}
            <strong>
              {data?.prefixo} - {data?.nome_dependencia}
            </strong>
          </p>
          <p className="m-0 mt-2 font-bold text-brand-blue">Clique para o Humanograma</p>
        </>
      }
    >
      <a
        href={`https://humanograma.intranet.bb.com.br/${data?._id}`}
        target="_blank"
        rel="noreferrer"
        className={`w-fit text-inherit hover:text-inherit focus:text-inherit ${FOCO_VISIVEL}`}
      >
        {children}
      </a>
    </Dica>
  );
};

export default Humanograma;
